
import { Phone, MessageCircle } from "lucide-react";
import { formatPhoneForWhatsApp } from "../utils/client-table-utils";

interface ClientContactsProps {
  telefono: string | null;
}

const ClientContacts = ({ telefono }: ClientContactsProps) => {
  if (!telefono) return <span>-</span>;

  return (
    <div className="flex flex-col gap-2">
      <a href={`tel:${telefono}`} className="flex items-center gap-1 hover:text-primary transition-colors">
        <Phone className="h-3 w-3" />
        <span>{telefono}</span>
      </a>
      <a 
        href={`https://wa.me/${formatPhoneForWhatsApp(telefono)}`} 
        target="_blank" 
        rel="noopener noreferrer" 
        className="flex items-center gap-1 text-green-600 hover:text-green-700 transition-colors"
      >
        <MessageCircle className="h-3 w-3" />
        <span className="text-xs">WhatsApp</span>
      </a>
    </div>
  );
};

export default ClientContacts;

